export const DynamicRowIdConstant = 'dynamic-row-price'
